import React, { useContext } from "react"
import { Redirect, Route } from "react-router-dom"
import { AuthContext } from "../context/Auth"

const PrivateRoute = (props) => {
    // const [validJWT, setValidJWT] = useState(false)
    // let history = useHistory()
    const { currentUser } = useContext(AuthContext)
    // console.log(currentUser, isAuthenticated)
    // let statusMessage = ''
    // const isValidSession = isAuthenticated()
    // if (!isValidSession) {
    //   statusMessage = "Your authentication session timed out"
    //   logoutUser(history, statusMessage)
    // }
    // console.log("is user session valid?", isValidSession)

    return currentUser ? (
        <Route {...props} />
    ) : (
        <Redirect
            to={{
                pathname: "/login",
                state: { redirectedFrom: props.location.pathname },
            }}
        />
    )
}

export default PrivateRoute
